<template>
  <section
      class="g-card flex-col"
      @click="onCardClick($event)"
      v-loading="loading"
      :style="{ cursor: disabledClick ? 'default' : 'pointer' }"
  >
    <div class="g-card__cover-box flex-row flex-center">
      <slot name="cover">
        <img class="g-card__cover" v-if="[GOODS_TYPE.entity,GOODS_TYPE.medal].includes(data.goodsType)"
             :src="data[dProps.cover] ? $api.staticUrl + data[dProps.cover] : DEFAULT_COVER" >
        <img class="g-card__cover" v-if="[GOODS_TYPE.course].includes(data.goodsType)"  :src="data[dProps.cover] || DEFAULT_COVER">
      </slot>
    </div>
    <div class="g-card__main flex-1 flex-col">
      <div class="g-card__head">
        <p class="g-card__title">{{ data[dProps.title] }}</p>
      </div>
      <el-tooltip
          effect="dark"
          :content="data[dProps.desc]"
          placement="bottom"
          popper-class="card-tooltip"
          :disabled="(data[dProps.desc] || '').length < 17 || data.goodsType !== GOODS_TYPE.medal"
      >
        <p class="g-card__desc ellipsis-1">{{ data[dProps.desc] }}</p>
      </el-tooltip>
      <!-- 积分兑换 -->
      <div v-if="showIntegral" class="g-card__integral-exchange flex-row">
        <img class="g-card__integral-icon" :src="require('@/assets/icon/integral.png')" alt="">
        <span class="g-card__integral-number">
                {{ data.point }}<span class="g-card__integral-tip">积分</span>
              </span>
        <div class="flex-1" />
        <el-popconfirm
            title="积分商品不支持退换，确认兑换吗？"
            :disabled="!$store.state.user.id || data.goodsType === GOODS_TYPE.entity"
            confirm-button-text="兑换"
            placement="top"
            v-model="showPopover"
            @confirm="$emit('exchange')"
        >
          <div slot="reference" class="g-card__exchange-btn" @click="onShowPopover">兑换</div>
        </el-popconfirm>
      </div>
      <!-- 限时 -->
      <template v-else-if="data.saleStatus === 1 && data.numLimit === 0">
        <div class="g-card__price-box flex-row">
          <span class="g-card__price">￥{{ data[dProps.salePrice] }}</span>
          <span style="display: inline-block; margin-left: 8px; text-decoration-line: line-through; color: #bbb">
            原价 {{ data[dProps.price] }} 元</span>
          <div class="flex-1" />
          <div class="g-card__activity-type-tag g-card__activity-type-tag--time flex-row">
            <img class="g-card__time-icon" :src="require('@/assets/icon/card-time_x2.png')" alt="">
            限时
          </div>
        </div>
        <p class="g-card__activity-type-tip">
          活动还有 <span style="color: #3355FF">{{ data.timeLeft }}</span> 结束
        </p>
      </template>
      <!-- 限量 -->
      <template v-else-if="data.saleStatus === 1 && data.numLimit === 1">
        <div class="g-card__price-box flex-row">
          <span class="g-card__price">￥{{ data[dProps.salePrice] }}</span>
          <span style="display: inline-block; margin-left: 8px; text-decoration-line: line-through; color: #bbb">
            原价 {{ data[dProps.price] }} 元</span>
          <div class="flex-1" />
          <div class="g-card__activity-type-tag g-card__activity-type-tag--count flex-row">
            限量
          </div>
        </div>
        <p class="g-card__activity-type-tip">抢购特价还有 <span style="color: #3355FF">{{ data.saleNum }}个</span> 名额
        </p>
      </template>
      <!-- 当商品不是出现在积分商城，也不是限时 | 限量，那么就会出现点赞信息 -->
      <template v-else>
<!--        <div v-if="typeof data[dProps.price] === 'number'" class="g-card__price-box flex-row">
          <span v-if="data[dProps.price] === 0" class="g-card__price">免费</span>
          <span v-else class="g-card__price">￥{{ data[dProps.price] }}</span>
        </div>-->
        <div class="g-card__menus flex-row">
          <div class="g-card__menu flex-row">
            <el-tooltip class="item" effect="dark" content="点击数" placement="bottom-start">
              <g-icon icon-class="review" style="width: 20px; height: 18px; margin-right: 8px;" />
						</el-tooltip>
            <span class="g-card__menu-text">{{ data.hits || 0 }}</span>
          </div>
          <div class="g-card__menu flex-row">
            <el-tooltip class="item" effect="dark" content="收藏数" placement="bottom-start">
              <g-icon icon-class="collection" style="width: 20px; height: 18px; margin-right: 8px;" />
            </el-tooltip>
            <span class="g-card__menu-text">{{ data.favorites || 0 }}</span>
          </div>
          <div class="g-card__menu flex-row">
            <el-tooltip class="item" effect="dark" content="评论数" placement="bottom-start">
              <g-icon icon-class="comment" style="width: 20px; height: 18px; margin-right: 8px;" />
            </el-tooltip>
            <span class="g-card__menu-text">{{ data.comments || 0 }}</span>
          </div>
        </div>
      </template>
    </div>
    <div class="flex-1" />
    <div slot="footer" class="g-card__buy">
      <!-- 购买人数 -->
      <span v-if="data.goodsType === GOODS_TYPE.course">已有 {{ data.buyCount || 0 }} 人购买</span>
      <!-- 库存 -->
      <span v-else-if="data.goodsType === GOODS_TYPE.entity && data.inventory===0">已售罄</span>
      <span v-else-if="data.goodsType === GOODS_TYPE.entity">库存还剩 <span style="color: #3355FF;">{{ data.inventory }}份</span></span>
      <!-- 勋章兑换人数 -->
      <span v-else>已有 {{ data.buyCount || 0 }} 人兑换</span>
    </div>
    <!-- 存在实体书籍的兑换，如果把 兑换 集成在当前组件的话，无关代码太多 -->
  </section>
</template>

<script>
const DEFAULT_PROPS = { // 默认的 props，防止对象字段不一样，但是目前是一样的，这块可以忽略
  cover: 'imgUrl', // 封面
  title: 'goodsName', // 标题
  desc: 'goodsDes', // 描述
  price: 'price', // 价格，如果是限时 | 限量 活动，这个字段是原价
  salePrice: 'salePrice', // 现价
}

const GOODS_TYPE = {
  course: 1, // 虚拟课程
  entity: 2, // 实体课程，书籍
  medal: 3, // 勋章
}
const GOODS_TYPE_ARRAY = ['', '课程', '实体', '勋章'] // 数组形式
const DEFAULT_COVER = require('@/assets/img/course-img.png');
export default {
  name: "g-card",
  emits: ['click', 'exchange'], // 点击事件 | 兑换事件
  props: {
    props: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      required: true
    },
    showIntegral: Boolean, // 显示积分，在积分商城场景，手动指定改值为 true，就会忽略 限时 | 限量 字段
    loading: Boolean, // 卡片 loading 状态
  },
  computed: {
    disabledClick () {
      return this.showIntegral && this.data.goodsType !== GOODS_TYPE.course
    }
  },
  data () {
    return {
      DEFAULT_COVER,
      dProps: Object.freeze(Object.assign({}, DEFAULT_PROPS, this.props)),
      GOODS_TYPE: Object.freeze(GOODS_TYPE),
      GOODS_TYPE_ARRAY,
      showPopover: false
    }
  },
  inject: ["onShowLoginModal"],
  methods: {
    onCardClick (ev) {
      if (ev.target.className.includes('el-popover__reference')) {
        return
      }
      if (this.disabledClick || this.data.goodsType === GOODS_TYPE.medal) {
        return
      }
      if (typeof this.$listeners.click === 'function') {
        return this.$listeners.click()
      }
      this.$router.push({ path: '/course', query: { courseId: this.data.id } })
    },
    /**
     * 积分兑换
     * 商品类型    订单类型
     * 课程 1  -  虚拟订单 4
     * 勋章3  -  虚拟订单 4
     * 实物商品2 - 实物订单1
     * @param {Object} [query] 额外的查询条件
     * @param {'alipay'} query.tradeChannel 交易渠道
     * @param {string} query.buyerName 买家昵称
     * @param {string} query.buyerTel 买家电话
     * @param {string} query.receiveAddress 买家收货地址
     * @return {Promise | Promise<any>}
     */
    onBuy (query) {
      return this.$post('/trading/api/shoporder/order', Object.assign( {
        goodsId: this.data.id,
        orderType: [null, 4, 1, 4][this.data.goodsType],
        userId: this.$store.state.user.id
      }, query))
    },
    onShowPopover () {
      if (!this.$store.state.user.id) {
        return this.$toast.fail({
          message: '请登录后操作',
        });
      }
      if (this.data.goodsType === GOODS_TYPE.entity && !this.data.inventory){
        return this.$message.error('库存不足, 无法兑换')
      }
      if (this.data.goodsType === GOODS_TYPE.entity) {
        // 实体书籍，采用 dialog 形式选择地址后兑换
        return this.$emit('exchange')
      }
      this.showPopover = true
    }
  }
}
</script>
<style>
.g-card__exchange-btn {
  padding: 0 8px;
  height: 18px;
  line-height: 18px;
  background: #3355FF;
  border-radius: 2px;
  cursor: pointer;

  font-size: 12px;
  color: #fff;
}
.g-card__exchange-btn:focus,
.g-card__exchange-btn:hover {
  background: #5C78FF;
}
.g-card__exchange-btn:active {
  background: #5C78FF;
}
.g-card__popconfirm .el-popconfirm__action {
  margin-top: 10px;
}
.g-card__popconfirm .el-button--primary span {
  color: #fff;
}
.card-tooltip {
  max-width: 275px;
}
</style>
<style scoped>
.g-card {
  width: 275px;
  border: 1px solid #ECEDED;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  line-height: 1;
  background: #fff;
  margin-right: 23px;
  margin-top: 24px;
  cursor: pointer;
  transition: .3s;
}

.g-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.g-card:nth-child(4n) {
  margin-right: 0;
}

.g-card__cover-box {
  background: #FAFAFA;
}

.g-card__cover-box,
.g-card__cover {
  object-fit: cover;
  width: 273px;
  height: 154px;
  border-radius: 4px 4px 0 0;
}

.g-card__main {
  padding: 16px;
  box-sizing: border-box;
  border-radius: 0 0 4px 4px;
}

.g-card__head {
  margin-bottom: 8px;
}

.g-card__title {
  font-size: 16px;
  color: #333;
}

.g-card__desc {
  font-size: 14px;
  color: #bbb;
  line-height: 14px;
  height: 14px;
  font-weight: 300;
}

.g-card__integral-exchange {
  margin-top: 16px;
  align-items: center;
}

.g-card__integral-icon {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.g-card__integral-number {
  font-size: 18px;
}

.g-card__integral-tip {
  margin-left: 4px;
  font-size: 12px;
}

.g-card__integral-number,
.g-card__integral-tip {
  color: #00BBB0;
}

.g-card__buy {
  box-sizing: border-box;
  border-top: 1px solid #ECEDED;
  padding: 20px 16px;
}
.g-card__buy span {
  font-size: 13px;
  color: #666;
  font-weight: 300;
}

.g-card__price-box {
  align-items: center;
  margin-top: 16px;
  height: 18px;
}

.g-card__price {
  font-size: 18px;
  color: #00BBB0;
}

.g-card__activity-type-tag {
  align-items: center;
  padding: 0 6px;
  height: 18px;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  margin-left: 12px;
}

.g-card__activity-type-tag.g-card__activity-type-tag--time {
  background: #FF4F4F;
}

.g-card__activity-type-tag.g-card__activity-type-tag--count {
  background: #FF820E;
}

.g-card__time-icon {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.g-card__activity-type-tip {
  font-size: 14px;
  line-height: 18px;
  margin-top: 16px;
}

.g-card__menus {
  align-items: center;
  margin-top: 16px;
}

.g-card__menu {
  align-items: center;
}

.g-card__menu + .g-card__menu {
  margin-left: 14px;
}

.g-card__menu-icon {
  width: 15px;
  height: 15px;
  margin-right: 8px;
}

.g-card__menu-text {
  font-size: 14px;
  color: #bbb;
  font-weight: 300;
}
</style>
